import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const SLIDES_PER_VIEW_PC = 5;
const SLIDES_PER_VIEW_SP = 2;
const SPACE_PC = 20;
const SPACE_SP = 16;
const LG_BREAKPOINT = 1024;
// loop表示で警告が出ないよう、常に確保する最小スライド数
const MIN_SLIDES = 10;

const topSectionBanner = () => {
    const el = document.querySelector('.js-top-section-banner-swiper');
    if (!el) return;

    const wrapper = el.querySelector('.swiper-wrapper');
    const originalSlides = Array.from(el.querySelectorAll('.swiper-slide'));
    const originalCount = originalSlides.length;
    if (originalCount === 0) return;

    // 元スライド数が MIN_SLIDES 未満の場合はクローンして補充
    if (originalCount < MIN_SLIDES) {
        const times = Math.ceil(MIN_SLIDES / originalCount);
        for (let i = 1; i < times; i++) {
            originalSlides.forEach(slide => {
                wrapper.appendChild(slide.cloneNode(true));
            });
        }
    }

    new Swiper(el, {
        modules: [Autoplay],
        loop: true,
        centeredSlides: true,
        watchOverflow: true,
        slidesPerView: SLIDES_PER_VIEW_SP,
        spaceBetween: SPACE_SP,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        breakpoints: {
            [LG_BREAKPOINT + 1]: {
                slidesPerView: SLIDES_PER_VIEW_PC,
                spaceBetween: SPACE_PC,
            },
        },
    });
};

export default topSectionBanner;
